export const Label = ({ children }) => <label>{children}</label>; 